"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layout_1 = require("./components/Layout");
var Login_1 = require("./components/Login");
var react_router_dom_1 = require("react-router-dom");
/*import { Router, Route } from 'react-router-dom';*/
require("bootstrap/dist/css/bootstrap.min.css");
require("./custom.css");
exports.default = (function () { return (React.createElement(Layout_1.default, null,
    React.createElement(react_router_dom_1.BrowserRouter, null,
        React.createElement(Login_1.default, null)))); });
//# sourceMappingURL=App.js.map